/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsFusionAppSetting
 */
export interface MelcoFusionModelsFusionAppSetting {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsFusionAppSetting
     */
    measurement_unit: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsFusionAppSetting
     */
    default_embroidery_production_file_format: string;
}

export function MelcoFusionModelsFusionAppSettingFromJSON(json: any): MelcoFusionModelsFusionAppSetting {
    return MelcoFusionModelsFusionAppSettingFromJSONTyped(json, false);
}

export function MelcoFusionModelsFusionAppSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsFusionAppSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurement_unit': json['measurement_unit'],
        'default_embroidery_production_file_format': json['default_embroidery_production_file_format'],
    };
}

export function MelcoFusionModelsFusionAppSettingToJSON(value?: MelcoFusionModelsFusionAppSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'measurement_unit': value.measurement_unit,
        'default_embroidery_production_file_format': value.default_embroidery_production_file_format,
    };
}


